const login = {
    state: {
        cdsjwtToken:'',
        // authenticationState:null,
        corporateName:'',
        headImgUrl:'',
    },
    mutations: {
        logout (state, vm) {

        }
    }
};

export default login;



// WEBPACK FOOTER //
// ./src/vuex/modules/login.ts